export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clientes.vue?vue&type=template&id=64003302&"


//////////////////
// WEBPACK FOOTER
// ./src/views/admin/clientes.vue?vue&type=template&id=64003302&
// module id = 300
// module chunks = 1